
<script>
// import { Line } from "vue-chartjs";
import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    // chartdata: {
    //   type: Object,
    //   default: null,
    // },
    options: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    // console.log(this.chartdata);
    this.renderChart(this.chartData, this.options);
  },
};
</script>
